"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetNearHoldingsMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
const domain_1 = require("../../../domain");
class GetNearHoldingsMapper {
    toDomain(result) {
        var _a, _b, _c;
        const hasError = !!lodash_1.default.get(result, "errors");
        const isLoading = lodash_1.default.get(result, "loading");
        const holdingInfo = (_c = (_b = (_a = lodash_1.default.get(result, "data.nearHoldings.edges")) === null || _a === void 0 ? void 0 : _a.map((o) => (Object.assign({}, o === null || o === void 0 ? void 0 : o.node.holding)))) === null || _b === void 0 ? void 0 : _b.filter(({ foodi }) => foodi)) === null || _c === void 0 ? void 0 : _c.map((eachHoldingInfo) => {
            var _a;
            return (Object.assign(Object.assign({}, eachHoldingInfo), { zones: (_a = eachHoldingInfo.zones) === null || _a === void 0 ? void 0 : _a.filter((eachZone) => eachZone.status === domain_1.ZoneStatus.VISIBLE) }));
        });
        return {
            hasError,
            isLoading,
            holdingInfo,
        };
    }
}
exports.GetNearHoldingsMapper = GetNearHoldingsMapper;
